import React, { useEffect, useState } from "react";
import { Box, List, ListItem, ListItemText } from "@mui/material";
import Headerbar from "./components/header";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import * as workpalJS from "@workpal-build/workpaljs";
import LoadingOverlay from "./components/loading_overlay";
import ReactGA from "react-ga4";

const styles = {
  list: {
    width: "100%",
    padding: 0,
    bgcolor: "background.paper",
  },
  listitem: { paddingTop: "16px", paddingBottom: "15px" },
  divider: {
    borderColor: "#D0D0D0",
    borderBottomWidth: "1.2px",
  },
};

const AllRelatedArticlesPage = () => {
  const { issueid } = useParams();
  const topicIssueList = useSelector((state) => state.data);
  const userapi = useSelector((state) => state.userapi);
  const [issue, setIssue] = useState(null);
  const [topic, setTopic] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [loadExternal, setLoadExternal] = useState(false);

  useEffect(() => {
    setHasSearched(false);
    setIssue(null);
    setTopic(null);

    if (!Array.isArray(topicIssueList) || topicIssueList.length === 0) return;

    let foundIssue = null;
    let foundTopic = null;

    for (const currentTopic of topicIssueList) {
      const matchedIssue = currentTopic.issues?.find((i) => i.id === issueid);
      if (matchedIssue) {
        foundIssue = matchedIssue;
        foundTopic = currentTopic;
        break;
      }
    }

    setIssue(foundIssue);
    setTopic(foundTopic);
    setHasSearched(true);
  }, [topicIssueList, issueid]);

  const articleList = issue?.kb ?? [];
  const topicId = topic?.id;
  const topicName = topic?.topic;
  const issueName = issue?.name;
  const issueId = issue?.id;

  const clickHandler = (url) => {
    setLoadExternal(true);
    setTimeout(() => {
      setLoadExternal(false);
      workpalJS.openExternalBrowser(String(url));
    }, 3000);
  };

  return (
    <div>
      {loadExternal ? (
        <LoadingOverlay
          isOpen={loadExternal}
          message={
            <div style={{ marginBottom: "10px" }}>
              Redirecting out of IT Support mobile
            </div>
          }
        />
      ) : (
        <div>
          <Headerbar title={"Related articles"} />
          {!issue ? (
            <div
              style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              {!hasSearched
                ? "Fetching related articles..."
                : "No related articles found"}
            </div>
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "100vh",
                backgroundColor: "#F8F8F8",
                paddingTop: "55px",
              }}
              noValidate
              autoComplete="off"
            >
              <List
                sx={styles.list}
                component="nav"
                aria-label="mailbox folders"
              >
                {articleList.map((kbArticle, index) => (
                  <div key={kbArticle.id}>
                    {kbArticle !== "Others" && (
                      <ListItem sx={styles.listitem} divider>
                        {kbArticle.kb_type === "kb_url" ? (
                          <Link
                            style={{ color: "#1D1D1D" }}
                            onClick={() => {
                              //For Google Analytics
                              ReactGA.gtag("event", "Tap Article", {
                                articleId: kbArticle.id,
                                articleName: kbArticle.short_description,
                                issueName: issueName,
                                issueId: issueId,
                                topicName: topicName,
                                topicId: topicId,
                                sessionIdCustom: userapi.sessionID,
                                userId: userapi.userSysId,
                                orgID: !userapi.orgId ? 0 : userapi.orgId,
                                agency: userapi.agency,
                                channel: "Mobile",
                                timestamp: Date(),
                              });

                              clickHandler(kbArticle.content);
                            }}
                          >
                            <ListItemText
                              primary={kbArticle.short_description}
                            />
                          </Link>
                        ) : (
                          <Link
                            to={`/relatedarticles/${index}`}
                            style={{ color: "#1D1D1D" }}
                            onClick={() => {
                              //For Google Analytics
                              ReactGA.event({
                                category: kbArticle.short_description, //issue
                                action: "Related Article", //topic
                                label: `Timestamp ${Date()}`,
                              });
                            }}
                          >
                            <ListItemText
                              primary={kbArticle.short_description}
                            />
                          </Link>
                        )}
                      </ListItem>
                    )}
                  </div>
                ))}
              </List>
            </Box>
          )}
        </div>
      )}
    </div>
  );
};

export default AllRelatedArticlesPage;
